import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { IS_API_GATEWAY } from '@personal-area/global/http/models';
import { RESUBMIT_FORM } from '@personal-area/global/captcha';

import { urls } from '../constants/urls';
import { RegisterRequest } from '../models/register';
import { RegisterResponse } from '../models/register-response';

@Injectable({ providedIn: 'root' })
export class RegistrationApiService {
  private _http = inject(HttpClient);

  public register(
    data: RegisterRequest,
    headers: HttpHeaders,
  ): Observable<RegisterResponse> {
    return this._http.post<RegisterResponse>(
      urls.register,
      {
        ...data,
        acceptedRules: true,
      },
      {
        headers,
        context: new HttpContext()
          .set(IS_API_GATEWAY, true)
          .set(RESUBMIT_FORM, {
            type: 'registration',
            form: {
              email: data.email,
              name: data.name,
            },
          }),
      },
    );
  }
}
